<template>
  <MksModal
    ref="modal"
    :active="show"
    @close="$emit('close')"
    class="modal-organizer"
    :title="_x('Contacter l\'organisateur', 'Titre modal contact organisateur')"
    size="medium"
  >
    <validation-form
      as=""
      v-slot="{ invalid, handleSubmit }"
    >
      <form @submit.prevent="handleSubmit(sendMail)" >
      <mks-spacer spacing="xl" class="modal-form">
        <mks-spacer>
          <validation-field v-show="!isLoggedIn || !profile" rules="required|email" v-model="email" v-slot="{field, errors}" name="email">
            <mks-field
              @update:modelValue="field.onChange"
              :model-value="field.value"
              :label="_x('Email *', 'Label du champ')"
              type="email"
              name="email"
              :placeholder="__('Saisis ton email...')"
            ></mks-field>
            <mks-field-error
              v-if="errors.length > 0"
              :error="errors[0]"
            ></mks-field-error>
          </validation-field>
          <validation-field rules="required" v-model="message" v-slot="{field, errors}" name="message">
            <mks-field
              @update:modelValue="field.onChange"
              :model-value="field.value"
              :label="_x('Message*', 'Label')"
              type="textarea"
              name="message"
              v-model="message"
              :placeholder="_x('Rédige ton message...', 'Placeholder')"
            ></mks-field>
            <mks-field-error
              v-if="errors.length > 0"
              :error="errors[0]"
            ></mks-field-error>
          </validation-field>
        </mks-spacer>
        <mks-button
          input-type="submit"
          tag="button"
          :disabled="sending"
          :loading="sending"
          >{{ _x("Envoyer", "Texte du bouton") }}</mks-button
        >
      </mks-spacer>
      </form>
    </validation-form>
  </MksModal>
</template>
<script>
import {mapGetters} from 'vuex';
import MksField from "@DS/components/Field.vue";
import MksModal from "@DS/components/Modal.vue";
export default {
  components: { MksField, MksModal },
  props: {
    event: {
        type: String,
        required: true
    },
    user: {
        type: String,
        required: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: "",
      message: "",
      sending: false,
    };
  },
  computed: {
    ...mapGetters('user', ['userLoading', 'isLoggedIn', 'profile'])
  },
  mounted() {
    if (this.isLoggedIn && this.profile) this.email = this.profile.email;
  },
  methods: {
    sendMail: function () {
      if (this.sending) {
        return;
      }
      this.sending = true;
      this.$store.dispatch('user/setEmail', this.email);
      this.$api.Events.contact(this.event, {
        email: this.email,
        body: this.message,
        user: this.user,
      })
        .then((res) => {
            this.sending = false;
            this.$toasted.show(this.__("Votre message a bien été envoyée."), {
                position: "bottom-center",
                duration: 4000,
                type: "success",
            });
            if (process.client) {
                setTimeout(() => {
                    this.$emit('close');
                }, 300);
            }

        })
        .catch((err) => {
          console.error(err);
          this.sending = false;
          this.$toasted.show(this.__("Erreur, veuillez réessayer."), {
                position: "bottom-center",
                duration: 4000,
                type: "error",
            });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-organizer {
  :deep(.modal) {
    background: $background-color-soft;
  }
  :deep(.modal__menu) {
    background: $background-color-softer;
  }
}
.modal-form {
  @include inner-space("xl");
}
</style>
